module.exports = __webpack_public_path__ + "static/cashew_nuts_vuon_3-81318c953b8ca14bfac1b4698a730f81.jpg";